const env = (window as any).env || process.env;

export const LOCALE = 'locale';
export const LOCALE_EN = 'en';
export const LOCALE_VI = 'vi';
export const API_URL = env.REACT_APP_API_URL;
export const API_CHAT_URL = env.REACT_APP_API_CHAT_URL;
export const ACCESS_TOKEN = env.REACT_APP_ACCESS_TOKEN;
export const ENCRYPT_PASSPHRASE = env.REACT_APP_ENCRYPT_PASSPHRASE;
export const PAGE_CONFIG = {
  pageSize: 10,
  pageMaxSize: 10000,
};

export const REGEX_PATTERN = {
  number: /^[0-9]+$/,
  password: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{8,}$/,
  phone: /(((\+|)84)|0)(3|5|7|8|9)+([0-9]{8})\b/,
  numberPositive: /^\d*(\.\d+)?$/,
  space: /^\S+$/,
};
export const MAX_NUMBER_FORMAT = 100000000000000;
export enum StatusCV {
  NEW = 11000,
  CV_WAITING = 11001,
  CV_SENT = 11002,
  CV_PASS = 11003,
  CV_FAIL = 11004,
  PV = 11005,
  PV_FAIL = 11006,
  OFFER = 11007,
  OFFER_FAIL = 11008,
  ONBOARD = 11009,
  ONBOARD_FAIL = 11010,
  PV2 = 11011,
  PV3 = 11012,
  WAIT_RESULT = 11017,
}

export enum Status1 {
  NEW = 15001,
  AA = 15002,
  AB = 15003,
  BA = 15004,
  BB = 15005,
}

export enum RankCompany {
  New = 13001,
  N1 = 13002,
  N2 = 13003,
  N3 = 13004,
  N4 = 13005,
  N5 = 13006,
  STOP = 13007,
  GUARANTEE = 13008,
  B0 = 13011,
}

export enum Role {
  ADMIN = 1,
  RECER = 2,
  AM = 3,
  SALE = 4,
  ROOT = 5,
  ACCOUNTANT = 6,
}

export const rolesCanNotRemove = ['admin', 'recer', 'am', 'sale'];
export enum MasterData {
  CV_PASS = 4,
  VC_FAIL = 5,
}

export enum Status {
  ACTIVE = 12001,
  DISABLED = 12000,
}

export enum Province {
  HANOI = 24,
}
export enum Language {
  ENGLISH = 9002,
}

export enum StatusSlidebar {
  collapse = 0,
  expand = 1,
  default = 2,
}

export const mimeType = [
  'application/pdf',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.ms-excel',
  'application/octet-stream',
  'application/vnd.ms-powerpoint',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  'text/csv',
  'image/gif',
  'image/jpeg',
  'image/jpg',
  'image/png',
  'image/svg',
  'audio/*',
];

export const imageType = [
  'image/gif',
  'image/jpeg',
  'image/jpg',
  'image/png',
  'image/svg',
];

export const mimeTypeExcel = [
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.ms-excel',
  // 'application/octet-stream',
];

export const ALLOW_TYPES_UPLOAD = ['pdf', 'PDF', 'docx', 'doc', 'csv', 'xlsx', 'xls', 'ppt', 'pptx'];
export const PREVIEW_FILE = ['docx', 'doc', 'csv', 'xlsx', 'xls', 'ppt', 'pptx', 'pdf'];

export const SETTING_SIDEBAR_ACCOUNTANT = [
  'setting/bank-acc',
  'setting/accounting',
  'setting/bill-analysis',
  'setting/partner',
  'setting/tax',
];

export const maxAllowedSize = 50 * 1024 * 1024;

export enum ChatTopic {
  LIST_CONTACT = 'topic/list_contact/online_offline',
}

/* NOTE: not change */
export enum TopicType {
  ON_LISTEN_PAIRING = 1,
  ON_RECEIVER_MSG = 2,
  ON_UPDATE_CONVERSATION = 3,
  ON_UPDATE_CONVERSATION_BY_ID = 4,
  ON_REACT_MESSAGE = 5,
}
export enum CheckExist {
  NO_EXIST = 0,
  EXIST = 1,
}

export enum LevelIntern {
  FULL_TIME = 8009,
  PART_TIME = 8008,
}

export const ACCOUNTANT_ACCESS_SETTING = [
  '/setting/partner',
  '/setting/bank-acc',
  '/setting/accounting',
  '/setting/bill-analysis',
  '/setting/tax',
];

export const EXCEPTION_PAGE = ['cv', 'job'];

export enum ContractStatus {
  SIGNED = 19000,
  NOT_SIGNED = 19001,
}
